<!-- eslint-disable @angular-eslint/template/no-call-expression -->
<div class="row mt-3">
  <div class="col">
    <h5 class="mb-2">Ausweis aktualisieren</h5>
  </div>
</div>
<div class="row">
  <div class="col-12">
    Lade ein Foto oder eine Kopie von Vorder- und Rückseite eines aktuell gültigen Personalausweises oder Reisepasses hoch.
    <br />Bitte achte darauf, dass alle Bestandteile des Ausweises lesbar sind.
  </div>
  <div class="col">
    <form (ngSubmit)="submitForm(f)" #f="ngForm">
      <div class="col-12 col-sm-6 col-md-4 mb-4 mt-4 pl-0">
        <div
          class="input-group-material"
          [class.input-group-material--error]="!identDocValidDateInputVar.value && identDocValidDateInputVar.touched"
        >
          <input
            type="text"
            [class.empty]="!identDocValidDateInputVar.value"
            ngModel
            name="identDocValidUntil"
            id="identDocValidUntil"
            #identDocValidDateInputVar="ngModel"
            ngbDatepicker
            #d="ngbDatepicker"
            [minDate]="validToDatePickerMinDate"
            (dblclick)="d.open()"
            webAppServicesGermanNgbDateValidator
            required
            placeholder="TT.MM.JJJJ"
          />
          <span class="input-group-material-icon-state" (click)="identDocValidDateInputVar.reset(null)"></span>

          <label for="identDocValidUntil"> Ausweis gültig bis </label>

          @if (identDocValidDateInputVar.hasError('ngbDate') && identDocValidDateInputVar.touched) {
            @if (identDocValidDateInputVar.getError('ngbDate')['minDate']) {
              <div class="input-group-material-message">Das Datum muss in der Zukunft liegen</div>
            }
            @if (!identDocValidDateInputVar.getError('ngbDate')['minDate']) {
              <div class="input-group-material-message">Bitte gib ein gültiges Datum an: TT.MM.JJJJ</div>
            }
          }
        </div>
      </div>
      <div class="mt-2 col-12 col-lg-8 pl-0">
        <h5 class="mb-2">Ausweiskopien</h5>
        @for (file of files; track $index) {
          <div>
            <div class="mb-0 mt-2 d-flex flex-wrap">
              <div>{{ file.fileName }}:&nbsp;</div>
              @if (!file.uploadError) {
                <div>{{ file.uploadInProgress ? 'wird' : 'wurde' }} hochgeladen</div>
              }
              @if ((file.uploadProgress === 100 && file.uploadInProgress === false) || file.uploadError) {
                <div>
                  <a class="cursor-pointer" (click)="deleteUploadedFile(file)">
                    <svg class="icon icon-24 icon-active mb-1 ml-2">
                      <use class="icon-trashcan" xlink:href="/assets/img/svgs/svgset.svg#trashcan" />
                    </svg>
                  </a>
                </div>
              }
              @if (file.uploadError) {
                <div class="ml-2 text-color-error">
                  {{ file.uploadError }}
                </div>
              }
            </div>
            <div class="progress">
              <div
                class="progress-bar"
                role="progressbar"
                [class.bg-success]="file.uploadProgress === 100 && file.uploadInProgress === false && !file.uploadError"
                [class.bg-danger]="file.uploadError"
                [ngStyle]="{ width: file.uploadProgress + '%' }"
                [attr.aria-valuenow]="file.uploadError ? '0' : file.uploadProgress"
                aria-valuemin="0"
                aria-valuemax="100"
              >
                {{ file.uploadError ? '0' : file.uploadProgress }} %
              </div>
            </div>
          </div>
        }

        @if (errors.length > 0) {
          <div class="row mt-3">
            <div class="col-12 text-color-error">
              @for (err of errors; track $index) {
                <p>{{ err }}</p>
              }
            </div>
          </div>
        }

        <form #fileUpload="ngForm" (ngSubmit)="submitFileUpload(fileUpload, fileUploadElem)" class="mt-3">
          <input
            type="file"
            id="tempFiles"
            name="tempFiles"
            ngModel
            (change)="fileUpload.onSubmit($event)"
            multiple="multiple"
            #fileUploadElem
            accept="application/pdf, image/*"
            hidden
          />
          <label for="tempFiles" class="d-flex align-items-center">
            <web-design-system-button
              type="secondary"
              size="small"
              class="mr-3"
              (click)="fileUploadElem.click()"
              [isSubmit]="true"
              [disabled]="files.length >= 2"
            >
              {{ files.length ? 'weiteres' : '' }} Dokument hochladen (.pdf, .jpg, .png)
            </web-design-system-button>
            <div class="font-size-smaller2 text-color-primary">(max. 9MB / Datei)</div>
          </label>
        </form>
      </div>

      <div class="mt-4">
        <label class="checkbox">
          Ich bestätige, dass der hochgeladene Ausweis gültig und lesbar ist.
          <input type="checkbox" id="confirmIdentDocValid" name="confirmIdentDocValid" class="custom-control-input" ngModel required />
          <span class="checkmark"></span>
        </label>
      </div>

      <div class="mt-4 d-flex align-items-center">
        <web-design-system-button
          class="mr-4"
          [disabled]="f.invalid || filesInProgress() || finished || !!dataToAuthorize || !files.length"
          [isSubmit]="true"
        >
          Aktualisierung autorisieren
        </web-design-system-button>
        <a class="link-secondary cursor-pointer" (click)="cancelUpdateIdentDoc()">Abbrechen</a>
      </div>
    </form>
  </div>

  @if (dataToAuthorize) {
    <div class="mt-2 p-3">
      <div class="row">
        <div class="col">
          <web-components-transaction-auth [payload]="dataToAuthorize" (transactionResult)="authorizedTransactionResult($event)" />
        </div>
      </div>
    </div>
  }

  @if (messageService.hasMessages$ | async) {
    <div>
      <div class="row">
        <div class="col">
          <web-components-user-messages />
        </div>
      </div>
    </div>
  }
</div>
